export default "__VITE_ASSET__CyuZeDQt__"